import CryptoJS from "crypto-js";

const decryptCookieData = (cookieName = "2xgxgshdugyywerw12gh") => {
  try {
    const storedData = localStorage.getItem(cookieName);
    if (!storedData) {
      console.warn("⚠️ No data found in localStorage.");
      return null;
    }

    // Check if already decrypted (plain JSON string)
    try {
      const parsed = JSON.parse(storedData);
      if (typeof parsed === "object" && parsed !== null) {
        return parsed; // ✅ Already decrypted, return directly
      }
    } catch (parseError) {
      // Not JSON yet, continue to decryption
    }

    const secret = "BILLION10";
    const bytes = CryptoJS.AES.decrypt(storedData, secret);
    const decryptedText = bytes.toString(CryptoJS.enc.Utf8);

    if (!decryptedText) throw new Error("Decryption failed or returned empty string");

    return JSON.parse(decryptedText);
  } catch (err) {
    console.error("❌ Failed to parse or decrypt cookie:", err);
    return null;
  }
};

export default decryptCookieData;
